<script setup lang="ts">
const props = withDefaults(defineProps<{
  content?: string | number
  color?: string
  dot?: boolean
  inline?: boolean
  modelValue?: boolean
  floating?: boolean
  offsetX?: number
  offsetY?: number
  size?: string
}>(), {
  modelValue: true,
  color: 'error',
})

const colorMap: Record<string, string> = {
  primary: 'var(--m-primary)',
  secondary: 'var(--m-secondary)',
  error: 'var(--m-error)',
  warning: 'var(--m-warning)',
  success: 'var(--m-success)',
  info: 'var(--m-info)',
}
</script>

<template>
  <div class="m-badge" :class="{ 'm-badge--dot': dot, 'm-badge--inline': inline }">
    <slot />
    <span
      v-if="modelValue"
      class="m-badge__badge"
      :class="{ 'm-badge__badge--x-small': size === 'x-small' }"
      :style="{
        backgroundColor: colorMap[color] || color,
        ...(inline ? {} : { transform: `translate(${offsetX || 25}%, ${offsetY || -25}%)` }),
      }"
    >
      <template v-if="!dot">{{ content }}</template>
    </span>
  </div>
</template>

<style scoped>
.m-badge {
  position: relative;
  display: inline-flex;
}

.m-badge__badge {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(25%, -25%);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: var(--m-radius-full);
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  line-height: 1;
  z-index: 1;
}

.m-badge--dot .m-badge__badge {
  min-width: 8px;
  height: 8px;
  padding: 0;
}

/* Inline mode: badge flows in text, no absolute positioning */
.m-badge--inline {
  display: inline-flex;
  align-items: center;
  gap: var(--m-space-1);
}
.m-badge--inline .m-badge__badge {
  position: static;
  transform: none;
}

/* x-small size */
.m-badge__badge--x-small {
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  font-size: 10px;
}
</style>
